/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProfileDto } from '../models/profile-dto';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUserProfile
   */
  static readonly GetUserProfilePath = '/user-profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile$Response(params?: {
  }): Observable<StrictHttpResponse<ProfileDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserProfileService.GetUserProfilePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfileDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile(params?: {
  }): Observable<ProfileDto> {

    return this.getUserProfile$Response(params).pipe(
      map((r: StrictHttpResponse<ProfileDto>) => r.body as ProfileDto)
    );
  }

  /**
   * Path part for operation linkUserProfile
   */
  static readonly LinkUserProfilePath = '/user-profile';

  /**
   * Set or update user profile
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `linkUserProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  linkUserProfile$Response(params?: {
    body?: ProfileDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserProfileService.LinkUserProfilePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Set or update user profile
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `linkUserProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  linkUserProfile(params?: {
    body?: ProfileDto
  }): Observable<void> {

    return this.linkUserProfile$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation validateEmail
   */
  static readonly ValidateEmailPath = '/user-profile/validate/{validateToken}';

  /**
   * Validate profile email
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateEmail$Response(params: {
    validateToken: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserProfileService.ValidateEmailPath, 'get');
    if (params) {
      rb.path('validateToken', params.validateToken, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Validate profile email
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `validateEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateEmail(params: {
    validateToken: string;
  }): Observable<void> {

    return this.validateEmail$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation setUserProfile
   */
  static readonly SetUserProfilePath = '/user-profile/user/{userId}';

  /**
   * Set or update user profile (admin)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setUserProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setUserProfile$Response(params: {
    userId: string;
    body?: ProfileDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserProfileService.SetUserProfilePath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Set or update user profile (admin)
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setUserProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setUserProfile(params: {
    userId: string;
    body?: ProfileDto
  }): Observable<void> {

    return this.setUserProfile$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
